import Bugsnag from "@bugsnag/js";
import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { FIREDB } from "../firebaseInstance";
import { logout } from "../Store/Actions";

const AVAILABLE_STATUS = "Available";

export const useProviderChatStatus = firebaseId => {
  const dispatch = useDispatch();
  const [providerChatStatus, setProviderChatStatus] = useState(null);
  const [expiresAt, setExpiresAt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!firebaseId) return;

    const dbRef = ref(FIREDB, "providerStatus/" + firebaseId);
    let expiryTimer = null;

    const fetchProviderChatStatusFromFirebase = () => {
      return onValue(dbRef, snapshot => {
        clearTimeout(expiryTimer);
        try {
          let userStatus = snapshot.val();
          if (userStatus) {
            const status = userStatus?.status;
            const expiresAt = userStatus?.expiresAt;
            if (typeof expiresAt == "number") {
              // The backend reset can run a few seconds late, so treat an
              // expired status as Available on the client straight away.
              const remaining = expiresAt - Date.now();
              if (remaining <= 0) {
                setProviderChatStatus(AVAILABLE_STATUS);
                setExpiresAt(null);
                return;
              }
              // setTimeout can't hold delays above 2^31-1 ms (~24.8 days)
              if (remaining < 2147483647) {
                expiryTimer = setTimeout(() => {
                  setProviderChatStatus(AVAILABLE_STATUS);
                  setExpiresAt(null);
                }, remaining);
              }
            }
            setProviderChatStatus(status || null);
            setExpiresAt(typeof expiresAt == "number" ? expiresAt : null);
          }
        } catch (err) {
          if (err?.code === "storage/unauthorized") {
            dispatch(logout());
          }
          console.error({ err });
          Bugsnag.notify(err);
          setProviderChatStatus(null);
        } finally {
          setIsLoading(false);
        }
      });
    };

    const unsubscribe = fetchProviderChatStatusFromFirebase();

    return () => {
      clearTimeout(expiryTimer);
      // detach only this hook's listener, not other components' on the same path
      unsubscribe();
    };
  }, [firebaseId]);

  return { isLoading, providerChatStatus, expiresAt };
};
